import { render } from "./disabled-dev-account.vue?vue&type=template&id=50749e8e&ts=true"
import script from "./disabled-dev-account.vue?vue&type=script&lang=ts"
export * from "./disabled-dev-account.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./disabled-dev-account.vue?vue&type=style&index=0&id=50749e8e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/workspace/ops/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__